;(function () {
	function dispatchFlexEvent(name, value) {
		gtag('event', name, {
			'data': value
		});
	}

	const datePicker = document.getElementById('product-rental-datepicker')
	const pickerWraper = document.querySelector('.card-rental .input-datepicker')
	// Open date picker
	pickerWraper?.addEventListener('click', () => dispatchFlexEvent('open_rental_calendar', true))
	datePicker?.addEventListener('change', function () {
		const targetValue = datePicker.value
		// Done start date
		if (targetValue) {
			const startDate = targetValue.split(' to ')
			dispatchFlexEvent('select_rental_date', startDate[0])
		}
		// Done end date
		const doneEndDate = targetValue.includes('to')
		if (doneEndDate) {
			dispatchFlexEvent('select_available_dates', targetValue)
		}
	})

    // Confirm rental
	document.addEventListener('shopify:cart:lines-update', (event) => {
		const purchaseOption = document.querySelector('input[name="properties[_flex_conversion_purchase_option]"]')
		if (!purchaseOption || purchaseOption.value != '1') {
			return
		}

		if (event.action != 'add') {
			return
		}

		dispatchFlexEvent('confirm_rental', datePicker.value)
	})
})()
